import React, { useCallback, useState } from 'react'
import { useDispatch } from 'react-redux'
import { createInventoriesAction } from '../../../store/inventory'
import { Form, Input } from 'antd'
import _ from 'lodash'
import ProjectSelector from '../../ProjectSelector'
import StockroomSelector from '../../StockroomSelector'
import { OPERATION_MOVE } from '../constants'
import InventoryOperationModalForm from './InventoryOperationModalForm'

const { TextArea } = Input

const MoveInventoryOperationModal = ({ equipmentIds, showModal, onCancel, onFinish }) => {
  const dispatch = useDispatch()

  const [validation, setValidation] = useState({})

  const onFinishAction = useCallback(
    async (data) => {
      let result = await dispatch(
        createInventoriesAction({
          ...data,
          type: OPERATION_MOVE,
          equipments: equipmentIds,
        })
      ).unwrap()
      onFinish(equipmentIds)
      return result
    },
    [dispatch, equipmentIds]
  )

  const validator = useCallback(({ project, stockroom }) => {
    let validation = {}
    if (project && stockroom) {
      validation = {
        ...validation,
        project: { validateStatus: 'error', help: 'Выберите проект или склад' },
        stockroom: { validateStatus: 'error', help: 'Выберите проект или склад' },
      }
    }
    if (!project && !stockroom) {
      validation = {
        ...validation,
        project: { validateStatus: 'error', help: 'Выберите проект или склад' },
        stockroom: { validateStatus: 'error', help: 'Выберите проект или склад' },
      }
    }

    setValidation(validation)
    return _.isEmpty(validation)
  }, [])

  const onCancelAction = useCallback(() => {
    setValidation({})
    onCancel()
  }, [onCancel])

  const onValuesChange = useCallback(() => setValidation({}), [])

  return (
    <InventoryOperationModalForm
      title="Карточка операции передачи"
      formName="move-inventory-operation"
      messageKey="move_inventory"
      showModal={showModal}
      onValuesChange={onValuesChange}
      onFinish={onFinishAction}
      onCancel={onCancelAction}
      validator={validator}
    >
      <Form.Item
        style={{ width: 450, maxWidth: 450 }}
        label="Проект"
        name="project"
        validateStatus={validation.project?.validateStatus}
        help={validation.project?.help}
      >
        <ProjectSelector />
      </Form.Item>
      <Form.Item
        style={{ width: 300, maxWidth: 300 }}
        label="Склад"
        name="stockroom"
        validateStatus={validation.stockroom?.validateStatus}
        help={validation.stockroom?.help}
      >
        <StockroomSelector />
      </Form.Item>
      <Form.Item name="comment" label="Комментарий" labelCol={{ span: 24 }}>
        <TextArea rows={4} />
      </Form.Item>
    </InventoryOperationModalForm>
  )
}

export default MoveInventoryOperationModal
